<div>
  <tc-login-form
    *ngIf="!identity"
    (emailAndPasswordSubmitted)="loginUser.emit($event)"
    (emailSubmitted)="checkEmailDomain.emit($event)"
    [pending]="loginState!.pending"
    [attempts]="loginState!.attemptsLeft"
    [bannedTime]="loginState!.bannedTime"
    [errorMessage]="loginState!.loginError"
    [showPasswordField]="loginState!.showPasswordField"
  >
  </tc-login-form>

  <tc-verify-2fa-code
    *ngIf="identity && identity.status === 'needs_2fa_code_verification' && (shouldVerifyWithBackupCode$ | async) === 'verification'"
    [identity]="identity"
    [verify2FAError]="loginState!.verify2FAError"
    (submitted)="verify2FA.emit($event)"
    (backToLogin)="onBackToLogin()"
    (switchToBackup)="onSwitchToFormWithBackup()"
  >
  </tc-verify-2fa-code>
  <tc-verify-via-recovery-code
    *ngIf="identity && identity.status === 'needs_2fa_code_verification' && (shouldVerifyWithBackupCode$ | async) === 'backup'"
    [identity]="identity"
    [verify2FAError]="loginState!.verify2FAError"
    (submitted)="verify2FAViaBackup.emit($event)"
    (backToVerification)="onBackToVerification()"
  >
  </tc-verify-via-recovery-code>
  <mat-card
    class="tc-container tc-container--small"
    style="margin-top: -40px; z-index: 1"
    *ngIf="identity?.status === 'needs_2fa_setup' || !!(backupCodes$ | async)?.length"
  >
    <mat-card-title
      i18n="title @@auth.2fa"
    >Setup 2FA</mat-card-title>
    <mat-card-content>
      <tc-setup-2fa></tc-setup-2fa>
    </mat-card-content>
  </mat-card>
</div>
